var itag_tools = 'US:Corp:AtWorkRecon:Company:'+getDocValue('companyIdApplication');
var itag_l1 = 'US';
var itag_language = 'en';
var csrfHeader = getDocValue('csrfHeaderNameApplication');
var csrfToken = getDocValue('csrfTokenApplication');
var csrfParameterName = getDocValue('csrfParameterNameApp');

function getDocValue(id){
    if( document.getElementById(id) ) {
        return document.getElementById(id).value;
    }
    return '';
}




//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/application.js
// module id = 423
// module chunks = 0